var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmarkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.736 2.718a.4.4 0 01-.005.555L6.552 15.708a.4.4 0 01-.571 0L.269 9.876a.4.4 0 01-.005-.554l2.283-2.416a.4.4 0 01.576-.005l2.858 2.917a.4.4 0 00.571 0l9.325-9.52a.4.4 0 01.576.004l2.283 2.416z",
    fill: "#010118"
  })));
}

export default SvgCheckmarkinline;